import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleVessel = {
  namespaced: true,

  state: {
    name: 'vessel',
    nextSeqCode: null,

    vessel: null, 
    vessels: [],
    vesselsMap: {},
    vesselNames: [],
    vesselsFilterData: []
  },

  mutations,
  getters,
  actions
}

export default moduleVessel;